
import './EmptyTodo.css';
function EmptyTodo(){
    
    
    return (
      <div>
        No existen todos. Por favor, cree uno
      </div>
      
    );
}
export { EmptyTodo };